export const FirebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_KEY,
	authDomain: "believe-374c6.firebaseapp.com",
	projectId: "believe-374c6",
	storageBucket: "believe-374c6.appspot.com",
	messagingSenderId: "351892000996",
	appId: "1:351892000996:web:0088d07a5d8da61a951cf1",
	measurementId: "G-ZQP8SYV7XL"
  };
